// Two different dimensions on `invoices` (Gary, 2026-09-29 -- mixing them up made every invoice
// insert fail the live invoices_invoice_type_check):
//  - invoice_type     = kind of document: 'INVOICE' | 'CREDIT_NOTE'  (always 'INVOICE' until the
//                       Credit Note feature exists)
//  - invoice_category = kind of invoice: 'IMPORT' | 'DUTY_VAT'         (drives the PDF title, the
//                       "D" number suffix, the "THIS IS A DUTY & VAT INVOICE" banner and the due date)
export type InvoiceCategory = 'IMPORT' | 'DUTY_VAT'

export const INVOICE_CATEGORIES: { value: InvoiceCategory; label: string }[] = [
  { value: 'IMPORT', label: 'Import Invoice' },
  { value: 'DUTY_VAT', label: 'Duty & VAT Invoice' },
]

export function invoiceCategoryLabel(category: string | null | undefined): string | null {
  return INVOICE_CATEGORIES.find(c => c.value === category)?.label ?? null
}

export function isDutyVat(category: string | null | undefined): boolean {
  return category === 'DUTY_VAT'
}
